import CustomerViewContents from './CustomerViewContents'
export default CustomerViewContents
